import { useState, useEffect } from "react";
import docx from "../../assets/images/ahead.png";
import pdf from "../../assets/images/ahead.png";

const CMSFormFile = (props) => {
  const { name, label, form, required, className, disabled, helpMessage } =
    props;

  const initialFileURL = form.values[name]
    ? process.env.REACT_APP_BACKEND_URL + "public/" + form.values[name]
    : null;

  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState(initialFileURL);
  const [fileName, setFileName] = useState("Choose file");
  const [fileTypeIcon, setFileTypeIcon] = useState(null);

  useEffect(() => {
    if (!file || !file.name) return;

    setFileURL(URL.createObjectURL(file));
    setFileName(file.name);

    // Set icon based on type
    const ext = file.name.split(".").pop().toLowerCase();
    if (ext === "pdf") setFileTypeIcon(pdf);
    else if (ext === "doc" || ext === "docx") setFileTypeIcon(docx);
    else setFileTypeIcon(null);

    return () => URL.revokeObjectURL(fileURL);
  }, [file]);

  const onFileChange = (e) => {
    if (e.target && e.target.files[0]) {
      setFile(e.target.files[0]);
      form.setFieldValue(name, e.target.files[0]);
    } else {
      clearFile();
    }
  };

  const clearFile = () => {
    setFile(null);
    setFileURL(null);
    setFileName("Choose file");
    setFileTypeIcon(null);
    form.setFieldValue(name, "", true);
    form.setFieldTouched(name, true);
  };

  return (
    <div
      className={`form-group w-full flex flex-col relative ${
        className ? className : ""
      }`}
    >
      <label
        htmlFor={name}
        className={`text-[19px] lg:text-21pt text-green ${
          required ? "required" : "notRequired"
        } ${form.touched[name] && form.errors[name] ? "isInvalidText" : ""}`}
      >
        {label} {required  && <span className="text-20pt text-orange">*</span>}
      </label>

      {/* File upload container styled like input */}
      <div
        className={`w-full h-[56px] mt-1 px-3 font-mono  flex items-center justify-between border bg-white rounded-[15px]
         border-green
          focus-within:ring-2 focus-within:ring-green focus-within:ring-opacity-50
          cursor-pointer ${disabled ? "bg-gray-200 cursor-not-allowed" : ""}`}
        onClick={() => !disabled && document.getElementById(name)?.click()}
      >
        <span
          className={`${
            fileName === "Choose file" ? "text-gray-400" : ""
          } w-[80%] text-18pt overflow-hidden whitespace-nowrap truncate`}
        >
          {fileName}
        </span>

        {fileName && fileName !== "Choose file" && (
          <button
            type="button"
            className="text-orange text-sm"
            onClick={(e) => {
              e.stopPropagation();
              clearFile();
            }}
          >
            Clear
          </button>
        )}
      </div>

      {/* Hidden file input */}
      <input
        type="file"
        id={name}
        className="hidden"
        accept=".pdf,.doc,.docx"
        onChange={onFileChange}
        onBlur={form.handleBlur}
        disabled={disabled}
      />

      {/* Error message */}
      {form.touched[name] && form.errors[name] && (
        <span className="errorMessage text-red-500 mt-1">
          {typeof form.errors[name] === "object"
            ? form.errors[name].message
            : form.errors[name]}
        </span>
      )}
    </div>
  );
};

export default CMSFormFile;
